import { Component, Input } from '@angular/core';
import { isNotNullOrUndefined, System } from 'ngx-core-services';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Store } from '@ngrx/store';

import { CreateBlockReduxSupport, IReduxBlock } from '../../store/helpers/decorator';
import { selectedSystemSource, SystemsState } from '../../store';
import { labels } from '../create-block/create.model';

@CreateBlockReduxSupport()
@Component({
  selector: 'settings-block',
  templateUrl: './settings-block.component.html',
  styleUrls: ['./settings-block.component.scss'],
})
export class SettingsBlockComponent implements IReduxBlock {
  @Input() refresh$ = new Subject<void>();
  _refresh$ = new Observable<boolean>();
  readonly _instanceId$: Observable<string> = new Observable<string>();
  readonly system$ = new BehaviorSubject<System|undefined>(undefined);
  @Input() system?: System;

  readonly _labels = labels;
  @Input() set labels(value: Partial<typeof this._labels>) {
    Object.assign(this._labels, value);
  }
  get labels(): typeof labels{
    return { ...this._labels };
  }

  constructor(readonly store: Store<SystemsState>) {}

  readonly systemSource$ = this.store.select(selectedSystemSource).pipe(
    isNotNullOrUndefined(),
  );
}
